import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { environment } from "environments/environment";
import { BrokenlinkResponse } from "app/core/models/brokenlink-response";

@Injectable()
export class BrokenlinkService {

  constructor(private _httpClient: HttpClient) { }

  public getBrokenlinks(filter: string, sortDirection: 'asc' | 'desc'| '', sortField: string, 
                      pageIndex: number, pageSize: number, activeFilters: Object[]): Observable<BrokenlinkResponse> {
    // seteamos los filters
    let allStringFilterAux = [];
    activeFilters.forEach((item, index) => {
      if (item['value'] != null && item['value'] != '') {
        let stringFilterAux = [item['id'],item['value']];
        allStringFilterAux.push(stringFilterAux.join('::'));
      }
    });

    let queryFilter = allStringFilterAux.join('--');

    // Seteamos los params
    let params = new HttpParams()
    .set('page', pageIndex.toString())
    .set('page_size', pageSize.toString())
    .set('sf', sortField?.toString())
    .set('s', sortDirection?.toString().toUpperCase())
    .set('f', queryFilter);

    return this._httpClient.get(`${environment.apiUrl}/${environment.apiVersion}/broken_links`, {
      params: params
      }).pipe(
          // map(res =>  res["data"])
          map(res =>  <BrokenlinkResponse>res)
      );
  }

  getBrokenlink(id: string): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/${environment.apiVersion}/broken_links/${id}`);
  }
  
}
